import apiFetch from '../apiFetch'

export default function (saleId, approvalRoleCode, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Sale/${saleId}/ApproveByRole?approvalRoleCode=${approvalRoleCode}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
